import { useState, useLayoutEffect } from 'react';

const useWindowDimensions = () => {
  const [dimensions, setDimensions] = useState({
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,
  });

  useLayoutEffect(() => {
    function updateSize() {
      const { innerHeight, innerWidth } = window;
      setDimensions({ innerHeight, innerWidth });
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return dimensions;
};

export default useWindowDimensions;
